import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["alt", "src"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { generateSrcSet, getImageVariants } from '@ori/image-sizes-helper';
import useTestId from '@ori/testid-generator';
import { ImageWrapper } from "./styles";
import { IMAGE } from "../../common";
import { LazyImage } from "../LazyImage";
import { jsx as _jsx } from "react/jsx-runtime";
export var Image = function Image(_ref) {
  var _images$at;
  var alt = _ref.alt,
    src = _ref.src,
    htmlImageElementProps = _objectWithoutProperties(_ref, _excluded);
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var imagesVariants = {
    url: src,
    backgroundColor: '#f5f5f5',
    params: [{
      width: 389,
      height: 389,
      quality: 90
    }, {
      width: 486,
      height: 486,
      quality: 90
    }, {
      width: 525,
      height: 525,
      quality: 90
    }, {
      width: 640,
      height: 640,
      quality: 70
    }, {
      width: 720,
      height: 720,
      quality: 70
    }, {
      width: 828,
      height: 828,
      quality: 60
    }, {
      width: 1080,
      height: 1080,
      quality: 60
    }, {
      width: 1242,
      height: 1242,
      quality: 30
    }, {
      width: 1440,
      height: 1440,
      quality: 30
    }]
  };
  var images = getImageVariants(imagesVariants);
  return /*#__PURE__*/_jsx(ImageWrapper, {
    children: /*#__PURE__*/_jsx(LazyImage, _objectSpread(_objectSpread({}, htmlImageElementProps), {}, {
      alt: alt !== null && alt !== void 0 ? alt : src,
      srcSet: generateSrcSet(images),
      sizes: "(min-width: 600px) 40vw, 100vw",
      src: (_images$at = images.at(-1)) === null || _images$at === void 0 ? void 0 : _images$at.url,
      "data-testid": getTestId(IMAGE)
    }))
  });
};
//# sourceMappingURL=Image.js.map